// ScoreTimerBar.jsx
// Matches room.php's #timer (.timer-back, upper-left) and #points (.score,
// upper-right). Phase 2: seconds/points are placeholder values (0) passed in
// as props so the real timer/score hooks can be wired in later phases
// without touching this component.
import React from 'react';
import { formatElapsedTime } from '../../../games/escape-to-inner-peace/utils/formatTime';
import './ScoreTimerBar.css';

function ScoreTimerBar({ seconds = 0, points = 0 }) {
  return (
    <div className="escape-score-timer-bar">
      <div className="escape-timer-back" data-testid="escape-timer">
        Time:{formatElapsedTime(seconds)}
      </div>
      <div className="escape-score" data-testid="escape-points">
        Points: <span>{points}</span>
      </div>
    </div>
  );
}

export default ScoreTimerBar;
